module.exports = __webpack_public_path__ + "img/好年华.b6e0375.png";